import list from 'src/modules/employeeCategory/list/employeeCategoryListReducers';
import form from 'src/modules/employeeCategory/form/employeeCategoryFormReducers';
import view from 'src/modules/employeeCategory/view/employeeCategoryViewReducers';
import destroy from 'src/modules/employeeCategory/destroy/employeeCategoryDestroyReducers';
import importerReducer from 'src/modules/employeeCategory/importer/employeeCategoryImporterReducers';
import {combineReducers} from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
